<template>
  <div class="card">
    <Toast />
    <div class="title">Klaim Hadiah Mode Lovers</div>
    <div class="p-grid p-fluid p-formgroup-inline" v-if="!detail_invoice">
      <div class="p-field p-col-4">
        <InputText
          placeholder="Nomor Invoice"
          ref="invoice_number"
          invoice_lama="invoice_number"
          v-model="invoice_number"
          v-shortkey.push="['enter']"
        />
        <div>
          <small class="p-error" v-if="isError.invoice_number">{{
            error_msg.invoice_number
          }}</small>
        </div>
      </div>
      <div class="p-col-2 text-center">
        <Button @click="verifyInvoice()">
          <span v-if="loading">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
          <span class="p-button-label" v-else>Cek Invoice</span>
        </Button>
      </div>
    </div>

    <div class="p-grid p-fluid p-col" v-if="detail_invoice">
      <table class="table table-responsive">
        <thead class="thead-light">
          <tr>
            <th class="text-center">No</th>
            <th class="text-center">ID Barang</th>
            <th class="text-center">Kode Barang</th>
            <th class="text-center">Nama Barang</th>
            <th class="text-center">Qty</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in item_list" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.item_id }}</td>
            <td>{{ item.item_code }}</td>
            <td>{{ item.item_name }}</td>
            <td>{{ item.qty }}</td>
          </tr>
        </tbody>
      </table>
      <div class="p-col-2">
        <Button @click="finishClaimGift()">
          <span v-if="loading">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
          <span class="p-button-label" v-else>Proses</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      amount: null,
      detail_invoice: null,
      transaction: null,
      invoice_number: null,
      generateButton: true,
      item_list: [],
      qty: 0,
      total_price: 0,
      isError: {
        invoice_number: null,
        stock: false
      },
      error_msg: {
        invoice_number: null,
        eligable_gift: []
      },

      filter: {
        eligable_gift: []
      },
      loading: false
    }
  },
  mounted() {
    setTimeout(this.setFocus, 1000)
  },
  methods: {
    setFocus() {
      this.$refs.invoice_number.$el.focus()
    },
    verifyInvoice() {
      if (this.invoice_number != null) {
        this.loading = true
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/pos/invoices/${this.invoice_number}`
          )
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.detail_invoice = response.data.data.invoice
              this.item_list = response.data.data.items
              this.transaction = response.data.data.transaction
              this.invoice_number = ''
            } else {
              let msg = 'Invoice tidak valid'
              if (response.data.message == 'error.invalid_outlet') {
                msg = 'Outlet tidak valid'
              } else if (response.data.message == 'error.already_claimed') {
                msg = 'Sudah diklaim sebelumnya'
              }
              this.$toast.add({
                severity: 'error',
                summary: 'Not Eligible',
                detail: msg,
                life: 3000
              })
            }
          })
          .catch(error => {
            this.detail_invoice = null
            this.amount = null
            this.dataItem.cust_id = null
            this.dataItem.eligable_gift = []
            console.log(error)
            this.$toast.add({
              severity: 'error',
              summary: 'Invoice not found',
              detail: 'Please try another invoice',
              life: 3000
            })
          })
      } else {
        this.detail_invoice = null
        this.amount = null
        this.dataItem.cust_id = null
        this.isError.invoice_number = true
        this.error_msg.invoice_number = 'Nomor Invoice tidak boleh kosong'
      }
    },
    finishClaimGift() {
      this.loading = true
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
